import { useState } from "react";
import InputAnimated from "../inputAnimated/inputAnimated";
import './currencyInput.scss'
import Tooltip from "../Tooltip/Tooltip";

const CurrencyInput = ({onChange, currencySymbol = "$", tooltip = "", readOnly = false, disabled = false}) => {
    const [rawValue, setRawValue] = useState("0"); // Inicia con un "0"

    const handleChange = (e) => {
        let inputValue = e.target.value;

        // Eliminar caracteres no numéricos, excepto el punto decimal
        let cleanedValue = inputValue.replace(/[^0-9.]/g, "");

        // Eliminar puntos adicionales si hay más de uno
        cleanedValue = cleanedValue.replace(/\.(?=.*\.)/, "");

        // Si el valor está vacío o solo tiene ceros, volvemos a poner "0"
        if (cleanedValue === "" || cleanedValue === "0") {
            cleanedValue = "0";
        }

        // Si el valor comienza con "0" y no tiene ningún otro número después, lo eliminamos
        if (cleanedValue.length > 1 && cleanedValue.startsWith("0")) {
            cleanedValue = cleanedValue.substring(1);
        }

        // Guardar el valor sin formatear
        setRawValue(cleanedValue);

        // Llamar a la función onChange pasada como prop
        onChange(cleanedValue);
    };

    return (
        <div className="currency-input">
            <Tooltip text={tooltip}>
                <InputAnimated
                    type="text"
                    inputMode="decimal"
                    value={rawValue}
                    onChange={handleChange}
                    placeholder="Cantidad"
                    readOnly={readOnly}
                    disabled={disabled}
                />
            </Tooltip>
            <p className="money-symbol">{currencySymbol}</p>
        </div>
    );
};

export default CurrencyInput;
